/**
 * Created by chenqifeng on 2016/8/30.
 */

import maple from 'maple';
import domain from './domain';
import url from './util/url';
import * as cookie from './util/cookie';



/**
 * 增加参数
 */
export let addParams = function(href,data){
    return url.addParams(href,data);
};

/**
 * 删除参数
 */
export let removeParams = function(){
    return url.removeParams.apply(url,arguments);
};

/**
 * 获取url参数
 * @returns {{}}
 */
export let getUrlParams = function(){
    return url.getUrlParams();
};

/**
 * 将url转化为绝对路径
 * @param url
 * @returns {boolean}
 */
export let toAbsUrl = function(url){
    if(!url){
        return false;
    }
    var a = document.createElement('a');
    a.href = url;
    return a.href;
};

/**
 * 设置cookie
 */
export let setCookie = function(key,value,time){
    return cookie.setCookie(key,value,time);
};

/**
 * 获取cookie
 */
export let getCookie = function(key){
    return cookie.getCookie(key);
};

/**
 * 删除cookie
 */
export let removeCookie = function(key){
    return cookie.removeCookie(key);
};


/**
 * 获取默认狗图
 */
export let getDefaultImageUrl = function(){
    return '//image1.51tiangou.com/tgou2/img2/tgou_logo4.png';
};

/**
 * 获取最近的A连接
 */
export let findClosestLink = function(ele){
    while ( ele ) {
        if ( ( typeof ele.nodeName === "string" ) && ele.nodeName.toLowerCase() === "a" ) {
            break;
        }
        ele = ele.parentNode;
    }
    return ele;
};

export let replaceState = function(state,title,url){
    title = title || document.title;
    var that = this;
    if(maple.support.replaceState){
        history.replaceState(state, title, url);
    }
};

